import { Icon, ExpandedTooltip } from '@livable/saas-react-components';
import { Typography, Chip, IconButton } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
// import { useStore } from 'src/stores';
import useStyles from './styles';
import { useTranslation } from 'react-i18next';
export const Item = observer(
// eslint-disable-next-line @typescript-eslint/no-unused-vars
_ref => {
  let accountId = _ref.accountId,
    linkedOn = _ref.linkedOn,
    description = _ref.description,
    userRole = _ref.userRole,
    isActive = _ref.isActive,
    status = _ref.status,
    handleAccountSwitch = _ref.handleAccountSwitch,
    accountMetadata = _ref.accountMetadata;
  // const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const temporaryDescriptionParser = descriptionString => {
    if (!descriptionString) {
      return {
        propertyAddress: 'N/A',
        unitName: 'N/A',
        billingStartDate: 'N/A'
      };
    }
    const regex = /propertyAddress:\s*([^,]+(?:,[^,]+)*),\s*unitName:\s*([^,]+),\s*billingStartDate:\s*([^\s,]+)/;
    const match = descriptionString.match(regex);
    const result = match ? {
      propertyAddress: match[1],
      unitName: match[2],
      billingStartDate: match[3]
    } : {
      propertyAddress: 'N/A',
      unitName: 'N/A',
      billingStartDate: 'N/A'
    };
    return result;
  };
  const _ref2 = !!accountMetadata ? accountMetadata : temporaryDescriptionParser(description),
    propertyAddress = _ref2.propertyAddress,
    unitName = _ref2.unitName,
    billingStartDate = _ref2.billingStartDate;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.container) + (isActive ? ' active' : ''),
    onClick: () => {
      handleAccountSwitch({
        accountId,
        unitName
      });
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.iconBlock
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "door"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.descriptionBlock
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    type: "default",
    title: unitName,
    placement: "top"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, unitName)), /*#__PURE__*/React.createElement("div", {
    className: classes.descriptionBlockAddress
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, propertyAddress + '\n Billing start date: ' + billingStartDate), /*#__PURE__*/React.createElement(ExpandedTooltip, {
    type: "default",
    title: propertyAddress + '\n Billing start date: ' + billingStartDate,
    placement: "top"
  }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
    type: "info"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: classes.statusBlock
  }, /*#__PURE__*/React.createElement(Chip, {
    label: status === 'active' ? t('general.active') : t('general.inactive'),
    variant: status === 'active' ? 'success' : 'inactive'
  })));
});